import { dynamic_form_context_value } from '../types';

export function createDefaultDynamicFormContextValue(): dynamic_form_context_value {
    return { definition: {} };
}

export default createDefaultDynamicFormContextValue;
